import {
  EmailDetail,
  EmailList,
  EmailTestStatus,
  type EmailTestSendInput,
} from "@regigov/contracts";
import { api } from "./client";

/** Only exists when the API runs with EMAIL_TEST_UI=true (docs/email.md). */
export const emailTestApi = {
  status: () => api("/email-test/status", EmailTestStatus),
  send: (input: EmailTestSendInput) =>
    api("/email-test/send", EmailDetail, {
      method: "POST",
      body: JSON.stringify(input),
    }),
  emails: () => api("/email-test/emails?limit=20", EmailList),
  email: (id: number) => api(`/email-test/emails/${id}`, EmailDetail),
};
